export const INSTALL = "INSTALL";
export const UNINSTALL = "UNINSTALL";

export const BIND = 1;
export const UNBIND = 0;

export const INSTALL_STATUS = {
  [INSTALL]: "已安装",
  [UNINSTALL]: "未安装",
};

export const BIND_STATUS = {
  已绑定: BIND,
  未绑定: UNBIND,
};

export const INSTALL_STATUS_OPTIONS = Object.keys(INSTALL_STATUS).map(
  (status) => ({
    value: status,
    label: INSTALL_STATUS[status],
  })
);

export const BIND_STATUS_OPTIONS = Object.keys(BIND_STATUS).map((status) => ({
  value: BIND_STATUS[status],
  label: status,
}));

//分账类型
export const SPLIT_TYPE = {
  全部类型: "",
  点位分账: "POINT",
  渠道分账: "CHANNEL",
};


//测评管理
export const Audit_Staus={
  全部状态:0,
  未审核:1,
  已通过:2,
  未通过:3
}


export const SPLIT_TYPE_REVERSE = Object.keys(SPLIT_TYPE).reduce(
  (total, key, index) => {
    total[SPLIT_TYPE[key]] = key;
    return total;
  },
  {}
);

export const SPLIT_TYPE_OPTIONS = Object.keys(SPLIT_TYPE).map((type) => ({
  value: SPLIT_TYPE[type],
  label: type,
}));


//测评管理
export const Audit_Staus_OPTIONS=Object.keys(Audit_Staus).map((type)=>({
  value:Audit_Staus[type],
  label:type
}))


export const Audit_Staus_REVERSE = Object.keys(SPLIT_TYPE).reduce(
  (total, key, index) => {
    total[Audit_Staus[key]] = key;
    return total;
  },
  {}
);




//提现类型
export const WITHDRAWAL_TYPE = {
  支付宝: 1,
  银行卡: 2,
  微信: 3,
};

export const WITHDRAWAL_TYPE_REVERSE = Object.keys(WITHDRAWAL_TYPE).reduce(
  (total, key, index) => {
    total[WITHDRAWAL_TYPE[key]] = key;
    return total;
  },
  {}
);

export const WITHDRAWAL_TYPE_OPTIONS = Object.keys(WITHDRAWAL_TYPE).map(
  (type) => ({
    value: WITHDRAWAL_TYPE[type],
    label: type,
  })
);

export const OPERATION_STATUS = {
  0: "全部",
  1: "未运营",
  2: "运营中",
  3: "已结束",
};

export const OPERATION_COLOR = {
  0: "default",
  1: "warning",
  2: "success",
  3: "error",
};
export const OPERATION_OPTIONS = Object.keys(OPERATION_STATUS).map(
  (status) => ({
    value: status,
    label: OPERATION_STATUS[status],
  })
);

export const TOPUP_WAY = {
  0: "全部",
  3: "微信充值",
  4: "对公转账",
};

export const TOPUP_WAY_OPTIONS = Object.keys(TOPUP_WAY).map((way) => ({
  value: way,
  label: TOPUP_WAY[way],
}));

export const CONSUMPTION_TYPE = {
  1: "点位扣款",
  2: "屏保扣款",
};
export const CONSUMPTION_OPTIONS = Object.keys(CONSUMPTION_TYPE).map((way) => ({
  value: way,
  label: CONSUMPTION_TYPE[way],
}));

export const DeliveryCycle = {
  7: "7天",
  14: "14天",
  21: "21天",
  28: "28天",
};

export const DELIVERY_CYCLE_OPTIONS = Object.keys(DeliveryCycle).map(
  (cycle) => ({
    value: cycle,
    label: DeliveryCycle[cycle],
  })
);
